import { mapObjectize } from 'cityads-v3/utils/apiUtils';

import {
  GET_WM_OFFER_URLS,
  GET_WM_OFFER_URLS_SUCCESS,
  GET_WM_OFFER_URLS_FAIL,
} from "../actions/wmOfferUrls";

const initialState = {
  urlsByOfferId: {},
  urlsById: {},
};

function linksObjectize(links) {
  return mapObjectize(links, 'channel_id');
}

export default function wmOfferUrls(state = initialState, action = {}) {
  switch (action.type) {
    case GET_WM_OFFER_URLS:
      return {
        ...state,
        urlsByOfferId: {
          ...state.urlsByOfferId,
          [action.additional.offerId]: {
            data: [],
            isLoading: true,
            isLoaded: false
          }
        }
      }

    case GET_WM_OFFER_URLS_SUCCESS:
      const data = action.response.offerUrl.map(item => ({
        ...item,
        id: +item.id,
        links: linksObjectize(item.links)
      }));
      const dataById = mapObjectize(data);

      return {
        ...state,
        urlsByOfferId: {
          ...state.urlsByOfferId,
          [action.additional.offerId]: {
            data: data.map(item => item.id),
            dataById,
            isLoading: false,
            isLoaded: true
          }
        },
        urlsById: {
          ...state.urlsById,
          ...dataById
        }
      }

    case GET_WM_OFFER_URLS_FAIL:
      return {
        ...state,
        urlsByOfferId: {
          ...state.urlsByOfferId,
          [action.additional.offerId]: {
            data: [],
            isLoading: false,
            isLoaded: false
          }
        }
      }

    default:
      return state;
  }
}
